<template>
  <div :class="{ 'ring-offset-2 ring-primary-200 ring-4 rounded-md dark:ring-primary-800 dark:ring-offset-gray-900' : isActive }">
    <template v-if="isEnabled">
      <div class="w-full border px-3 py-1 rounded-md bg-gray-50 dark:bg-gray-900">
        <template v-for="(service, index) in services" :key="index">
          <discount-service
            v-if="service.service && service.employee && validationServices[index]"

            v-model:voucher="service.voucher"
            v-model:customerPass="service.customerPass"
            :service="validationServices[index]"
            :employee="service.employee"
            :staging="staging"
          />
        </template>
      </div>
    </template>

    <template v-else>
      <div class="bg-gray-50 border text-center rounded p-4 dark:bg-gray-900">
        <p class="text-gray-600 text-sm dark:text-gray-300">
          {{ $t('components.reservation.create.discounts.select') }}
        </p>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import DiscountService from './DiscountService.vue'

import {
  ToggleField,
} from '@/components/fields'

interface Props {
  staging: any
  state: string
  isActive: boolean
}

interface Emits {
  (e: 'update:staging', value: any): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const selected = ref<any[]>([])

const _staging = computed({
  get () {
    return props.staging
  },
  set (value) {
    emit('update:staging', value)
  },
})

const validation = computed(() => {
  return _staging.value.validation?.data ?? _staging.value.validation
})

const validationServices = computed(() => {
  return validation.value?.services ?? []
})

const services = computed(() => {
  return props.staging.availabilitySlot?.services ?? []
})

const isEnabled = computed(() => {
  return !!validation.value && !!props.staging.availabilitySlot
})
</script>
